import { gql } from '@common/hooks';
export type { FullValidationErrorFragmentFragment as FullValidationErrorFragmentType } from '@common/graphql/schema';

export const FullValidationErrorFragment = gql`
  fragment FullValidationErrorFragment on ValidationError {
    attribute
    humanAttribute
    errors
    fullErrors
  }
`;
